module.exports = __webpack_public_path__ + "static/media/Hi.3d428325.svg";